import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NgModule } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';

@NgModule({
    declarations: [
    ],
    imports: [
        MatCheckboxModule,
        MatInputModule,
        MatFormFieldModule,
        MatToolbarModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatOptionModule,
        MatSelectModule,
        MatPaginatorModule,
        MatTableModule
    ],
    exports: [
        MatCheckboxModule,
        MatInputModule,
        MatFormFieldModule,
        MatToolbarModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatOptionModule,
        MatSelectModule,
        MatPaginatorModule,
        MatTableModule
    ]
})

export class MaterialModule {}